<template>
  <section class="aboutSection">
    <div class="tinter"></div>
    <div class="aboutContainer">
      <div class="companyDetails">
        <h1 class="title">HIGHGROUND Inc.</h1>
        <div class="subTitle">
          <p>
            Highground technologies is globally recognized as an innovator and provider of AI based technology solutions. From news tand sports event Identification and notification, to the IOT and beyond. Highground is at the vanguard of the evolving field of artifical intelligence technology. Our clients range from news and sports media outlets to Critical Event Notifications System (CENS) clients in mineral extraction, energy, finance, security, transportation, legal and insurance.
          </p>
          <p>
            Highround's world-class capabilities are the result from years of research into natural language processing, more specifically in the areas of entity extraction, disambiguation sentence and though vector representation. we are also leaders in SPAM detection and topic classification as well as the detection of anomalies in multi-dimensional information flow.
          </p>
        </div>
      </div>
      <div class="teamDetails">
        <h1 class="title">The Team</h1>
        <div class="subTitle">
          The Team at Highground is comprised of experienced leaders on the frontier of artificial intelligence innovation.
          </div>
        <div class="profileDisplay">
          <div class="profileImage">
            <img :src="rob" alt="Rob-Vollero">
            <div class="overlay"></div>
          </div>
          <div class="profileDetails">
            <div>
              <h1>Rob Vollero</h1>
              <h2>Chief Executive Officer</h2>
              <p>A seasoned finance veteran with a focus on fundamental company analysis.</p>
            </div>
          </div>
          <div class="profileImage">
            <img :src="alex" alt="Alex-Zivkovic">
            <div class="overlay"></div>
          </div>
          <div class="profileDetails">
            <div>
              <h1>Alex Zivkovic</h1>
              <h2>Chief Technology Officer</h2>
              <p>A recognized Canadian leader in Artifical Intelligence based technologies.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AlexZiv from '@/assets/hgAbout/alexZiv.png';
import RobVoll from '@/assets/hgAbout/robVol.png';

export default {
  name: 'AboutPage',
  data() {
    return {
      alex: AlexZiv,
      rob: RobVoll
    }
  },
}
</script>

<style scoped>
@media (max-width: 800px) {
  .aboutContainer {
    position:relative;
    height: auto;
    z-index: 2;
    width: 100%;
    display: grid;
    background: #1e1e1e;
    grid-template-rows: 1fr 2fr;
    grid-gap: 3rem 3rem;
    padding-top: 2rem;
  }
  .companyDetails > h1 {
    color: white;
    font-size: 5vw;
    padding: 1rem;
    border-style: none none solid none;
    border-color: white;
  }
  .companyDetails {
    padding: 3rem 2rem;
    color: white;
    white-space: pre-line;
  }
  .teamDetails {
    padding: 0rem 2rem;
    color: white;
  }
  .teamDetails > h1 {
    color: white;
    font-size: 5vw;
    padding: 1rem;
    border-style: none none solid none;
    border-color: white;
  }
  .profileDetails > h1{
    margin-bottom: 0.2rem;
    font-size: 2.3vw;
  }
  .profileDetails > h2{
    margin-bottom: 0.1rem;
    margin-top: 0;
    font-weight: normal;
    font-size: 2vw;
  }
  .profileDetails > p{
    margin-bottom: 0;
    margin-top: 0;
    font-size: 1.8vw;
  }
  .profileImage > img {
    height: 200px;
    width: 200px;
  }
  .overlay {
    top: -70px;
    left: -70px;
    right: -100px;
    bottom: -100px;
    position: absolute;
    z-index: 2;
    width: 200px;
    height: 200px;
    background-color: transparent;
    border-radius: 200px;
    border: 70px solid #1e1e1e; 
    pointer-events: none; 
  }
}

@media (min-width: 800px) {
  .aboutSection {
    position: relative;
    background: url('../../assets/leaf.png') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;    
    -o-background-size: cover;      
    background-size: cover;
  }
  .tinter {
    background: #1e1e1e;
    position: absolute;
    opacity: 0.90;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
  }
  .aboutContainer {
    position:relative;
    height: auto;
    z-index: 2;
    width: 100%;
    display: grid;
    grid-template-rows: 1fr 2fr;
    grid-gap: 3rem 5rem;
    padding-bottom: 10rem;
  }
  .companyDetails {
    padding: 5rem 10rem;
    color: white;
    white-space: pre-line;
  }
  .companyDetails > h1 {
    color: white;
    font-size: 2vw;
    padding: 1rem;
    border-style: none none solid none;
    border-color: white;
  }
  .teamDetails {
    padding: 0rem 10rem;
    color: white;
  }
  .teamDetails > h1 {
    color: white;
    font-size: 2vw;
    padding: 1rem;
    border-style: none none solid none;
    border-color: white;
  }
  .profileDetails > h1{
    margin-bottom: 0;
    font-size: 1.8vw;
  }
  .profileDetails > h2{
    margin-bottom: 0;
    margin-top: 0;
    font-weight: normal;
    font-size: 1.5vw;
  }
  .profileDetails > p{
    margin-bottom: 0;
    margin-top: 0;
    font-size: 1.2vw;
  }
  .overlay {
    top: -70px;
    left: -70px;
    right: -100px;
    bottom: -100px;
    position: absolute;
    z-index: 2;
    width: 260px;
    height: 260px;
    background-color: transparent;
    border-radius: 200px;
    border: 70px solid #1e1e1e; 
    pointer-events: none; 
  }
}

.companyDetails > div {
  color: white;
}
.profileDisplay {
  margin-top: 3rem;
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-gap: 6rem 1.5rem;
}
.profileDetails {
  display: table;
  height: 100%;
  width: 100%;
}
.profileDetails > div{
  display: table-cell;
}
.profileImage {
  position: relative;
  height: auto;
  width: 100%;
  z-index: -1;
}

</style>
